<template>

  <b-modal
    id="modal-cancel-booking-dr"
    v-model="isOpen"
    size="md"
    centered
    ok-only
    :ok-title="$t('golf_common_confirm')"
    ok-variant="danger"
    @ok="cancelBooking_DBKD01"
  >
    <template #modal-header="{ close }">
      <h4 class="mb-0 text-danger">
        {{ $t('golf_booking_cancel_booking') }}
      </h4>
      <ez-icon
        icon="ezGolf-icon-x"
        class="cursor-pointer"
        size="24"
        color="#EA5455"
        @click="close"
      />
    </template>
    <b-card-body>
      <b-form>
        <div class="border-bottom pb-1 mb-1">
          <b-row>
            <b-col md="6">
              {{ $t('golf_boongking_group_name') }}:
              <span class="text-primary font-weight-bold">{{ data.GroupName }}</span>
            </b-col>
            <b-col md="6">
              {{ $t('golf_boongking_booking_code') }}:
              <span class="text-primary font-weight-bold">#{{ data.BookingCode }}
                (
                <ez-icon
                  icon="ezGolf-icon-user"
                  size="12"
                  color="#114A9F"
                />
                {{ data.TotalNumberOfGolfer }}
                )
              </span>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              {{ $t('golf_boongking_client_name') }}:
              <span class="text-primary font-weight-bold">{{ data.ClientName }}</span>
            </b-col>
            <b-col md="6">
              {{ $t('golf_boongking_source_name') }}:
              <span class="text-primary font-weight-bold">{{ data.SourceName }}</span>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('golf_common_reason_cancel_booking') + ':'">
              <b-form-textarea
                v-model="reason"
                :placeholder="$t('golf_common_reason_cancel_booking')"
                rows="3"
                no-resize
                maxlength="250"
              />
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="sendMail">
                <p class="mb-0">
                  {{ $t('golf_common_send_email_to_customer') }}
                </p>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-modal>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { bookingDrivingRange } from '@/api/booking-driving-range'

export default {
  name: 'CancelBooking',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: ['data'],
  data() {
    return {
      reason: '',
      sendMail: false,
      isOpen: false,
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.reason = ''
        this.sendMail = false
      }
    },
  },

  methods: {
    async cancelBooking_DBKD01() {
      const body = {
        BookingDrId: this.data.Id,
        SendMail: this.sendMail,
        Reason: this.reason,
      }

      const response = await bookingDrivingRange.api_DBKD01(body)
      this.showResToast(response)
      if (response.Status == 200) {
        this.$emit('event', { type: 'after-cancel-booking' })
      }
    },
  },
}
</script>

<style lang="scss">
#modal-cancel-booking-dr {
  .modal-header {
    background: rgba(234, 84, 85, 0.12) !important;
  }
}
</style>
